export enum ChangePasswordFormFieldEnum {
    CURRENT_PASSWORD = 'currentPassword',
    NEW_PASSWORD = 'newPassword',
    NEW_PASSWORD_REPEAT = 'newPasswordRepeat'
}